import type { ComponentPropsWithoutRef } from "react";
import capitalize from "lodash/capitalize";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { BlockCategory } from "@circle-react-shared/BuilderUI/DataModel.types";

export interface BlockCategoryListProps extends ComponentPropsWithoutRef<"ul"> {
  categories: BlockCategory[];
  onClickCategory: (category: BlockCategory) => void;
  selectedCategory?: BlockCategory;
}

export const BlockCategoryList = ({
  categories,
  selectedCategory,
  onClickCategory,
}: BlockCategoryListProps) => (
  <OverlayScrollbarsComponent className="bg-secondary w-1/3">
    <ul className="flex list-none flex-col gap-1 px-4 py-5">
      {categories.map(category => (
        <li key={category.name}>
          <button
            type="button"
            className={classNames(
              "text-xs-plus text-dark h-8.5 hover:bg-overlay-dark flex w-full items-center rounded-lg px-3 py-2 text-left font-medium transition-colors",
              {
                "bg-overlay-dark": selectedCategory?.name === category.name,
              },
            )}
            onClick={() => onClickCategory(category)}
          >
            {category.nameI18n
              ? t(category.nameI18n, {
                  defaultValue: capitalize(category.name),
                })
              : capitalize(category.name)}
          </button>
        </li>
      ))}
    </ul>
  </OverlayScrollbarsComponent>
);
